// extracted by mini-css-extract-plugin
export default {"containerDashboard":"dashboard_containerDashboard__zVsZc"};